module.exports = __webpack_public_path__ + "dist/media/logo--fi.5f310c53.svg";